<template>
  <v-dialog
    width="320"
    :value="value"
    @input="$emit('input', $event)"
    overlay-color="black"
    overlay-opacity=".7"
  >
    <v-card>
      <v-card-title>次の支払方法を削除しますか？</v-card-title>

      <v-card-text>
        <table class="w-full table-fixed pt-4">
          <tr>
            <th class="w-20 caption text-right">カード番号</th>
            <td class="pl-4 text--primary">{{target.cardNo}}</td>
          </tr>
          <tr>
            <th class="w-20 caption text-right">カード名義</th>
            <td class="pl-4 text--primary">{{target.holderName}}</td>
          </tr>
          <tr>
            <th class="w-20 caption text-right">有効期限</th>
            <td class="pl-4 text--primary">{{target.expire | timeformat('m / Y')}}</td>
          </tr>
        </table>
      </v-card-text>

      <c-card-errors :errors="errors"/>

      <v-card-actions>
        <v-spacer/>

        <!-- キャンセルボタン -->
        <v-btn text @click="$emit('cancel')">キャンセル</v-btn>

        <!-- 削除ボタン -->
        <v-btn text color="primary"
          :loading="running"
          :disabled="running"
          @click="onDelete"
        >
          削除
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CCardErrors from '@/components/CCardErrors'

export default {
  name: 'CPaymentDeleteDialog',
  components: {
    CCardErrors
  },

  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    // ダイアログの表示/非表示
    value: {},

    // 支払方法
    payment: {
      type: Object
    }
  },

  data: () => ({
    // エラーメッセージ
    errors: [],

    // 処理中
    running: false
  }),

  computed: {
    target () {
      return this.payment || {
        cardNo: '',
        holderName: '',
        expire: ''
      }
    }
  },

  watch: {
    value () {
      this.running = false
    }
  },

  methods: {
    /**
     * 削除ボタン
     */
    onDelete () {
      this.running = true
      this.$emit('delete', errors => {
        this.running = false
        if (errors) {
          this.errors = errors
        }
      })
    }
  }

}
</script>
